import type { FC } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { IcnBuilding, Shape1 } from '@alexanderathoodly/ui-library'
import { Calendly } from './Calendly'
import { Button, Text, Container, Flex, Skeleton } from '@chakra-ui/react'
import {
	OFFICE_TYPE,
	SORT_RECOMMENDED,
	useSerpUrlGenerator,
	FILTER_TYPE_OFFICE,
	COWORKING_TYPE,
	SERVICED_OFFICE_TYPE,
} from '~/routes/coworking_serp/urlGenerator'
import { useQuery } from 'react-query'
import { getCoworkingSearchResultQuery } from '~/queries/coworking_search_result'
import { useCoworkingSerpParams } from '~/routes/coworking_serp/utils'
import { useTranslation } from 'react-i18next'

const Confirmation: FC = () => {
	const { t } = useTranslation()
	const urlgenerator = useSerpUrlGenerator()
	const { pathname, search } = useLocation()
	const params = new URLSearchParams(search)
	const page = pathname.split('/')[1]
	const type =
		page === 'coworkinghjalpen'
			? COWORKING_TYPE
			: page === 'kontorshotellshjalpen'
			? SERVICED_OFFICE_TYPE
			: OFFICE_TYPE

	//if we have an email we allow the meeting booking
	const allowBookMeeting = !!params.get('email')
	const coworkingSearchParam = useCoworkingSerpParams()
	const urlToSerp = urlgenerator({
		areaCodes: coworkingSearchParam.areas,
		type,
		minWorkspaces: coworkingSearchParam.min_workspaces || 0,
		maxWorkspaces: coworkingSearchParam.max_workspaces || 0,
		maxBudget: coworkingSearchParam.budget || 0,
		services: [],
		sorting: SORT_RECOMMENDED,
		filterType: [FILTER_TYPE_OFFICE],
	})
	const searchResult = useQuery(
		getCoworkingSearchResultQuery({
			min_workspaces: coworkingSearchParam.min_workspaces,
			max_workspaces: coworkingSearchParam.max_workspaces,
			budget: coworkingSearchParam.budget,
			areas: coworkingSearchParam.areas,
			types: [FILTER_TYPE_OFFICE],
		})
	)
	return (
		<>
			<Container maxW={{ md: '730px', lg: '835px' }} pt={10}>
				<IcnBuilding boxSize={10} />
				<Shape1
					position="absolute"
					mx="auto"
					left={0}
					right={0}
					zIndex={-1}
					top="120px"
				/>
				<Flex
					direction="column"
					textAlign="center"
					color="blue.500"
					fontSize="md"
				>
					<Text fontSize="xl" mt={6} mb={3}>
						{t('Bra jobbat! Nu kan vi sätta igång.')}
					</Text>
					<Text>
						{t(
							'Nu kommer vi kolla igenom era behov och återkomma till dig för att fördjupa oss kring vad ni söker samt berätta hur vi jobbar. Vi kommer driva på projektet från start till slut och se till att ni hittar ett kontor som ni kan trivas i!'
						)}
					</Text>
					{allowBookMeeting ? (
						<Text>
							{t(
								'Du har nu möjlighet att boka in en tid för vårt första samtal, så det passar ditt schema.'
							)}
						</Text>
					) : null}
					<Text mb={4}>{t('Vi hörs snart!')}</Text>
					{searchResult.isLoading ? (
						<Skeleton w="100%" h={10} />
					) : (
						searchResult.isSuccess && (
							<Text>
								{t(
									'Medan ni väntar på vår återkoppling - passa på och spana in de {{locations_length}} kontorsalternativ {{found_locations}} direkt på marknadsplatsen.',
									{
										locations_length:
											searchResult.data.locations.length > 0
												? searchResult.data.locations.length
												: t('andra'),
										found_locations:
											searchResult.data.locations.length > 0
												? t('som vi hittade som matchar era sökkriterier')
												: '',
									}
								)}
							</Text>
						)
					)}
					<Button mt={5} mx="auto" as={Link} to={urlToSerp}>
						{t('Till marknadsplatsen')}
					</Button>
				</Flex>
			</Container>
			{allowBookMeeting ? <Calendly email={params.get('email')} /> : null}
		</>
	)
}

export { Confirmation }
